module.exports = __webpack_public_path__ + "img/reports_party.68d4651f.png";